import { trimFieldString } from "../util";

export function translateChangeNFacetColumns(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let new_columns = parseInt(args[0]);
  rules.push({
    category: "recommender",
    description: `Change facet columns`,
    specifier: { role: "view.facet" },
    action: "modify",
    option: {
      nColumns: new_columns
    }
  });
  return rules;
}

export function translateMakeSplit(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  if (args[0] === "by_field") {
    let field = trimFieldString(args[1]);
    let values = source?.datatype[field]?.values;
    let rule_split = {
      category: "recommender",
      description: `Make splits by ${args[1]}`,
      specifier: { role: "view" },
      action: "modify",
      option: {
        composition: "repeated",
        nColumns: parseInt(args[2]),
        split: {
          field: field,
          label: {
            items: []
          }
        }
      }
    };
    let rel_mark_label = (source.layer?.map((layer) => layer.text)?.flat() || []).filter((text) => text.type === "on-mark" && text.field === field)
    if (rel_mark_label?.length > 0) {
      rule_split.option.split.label.items = rel_mark_label[0].items || [{}];
      let label_width_limit = config.new_size[0] / rule_split.option.nColumns - 25;
      rule_split.option.split.label.items.forEach((item) => {
        item.width = Math.floor(Math.min(item.width, label_width_limit));
      })
    } else {
      rule_split.option.split.label.items.push({
        "align": "left",
        "anchor": "start",
        "fontSize": 13,
        "fontWeight": 100
      });
    }
    if (values) rule_split.option.split.values = values;
    rules.push(rule_split);
    if (source.layer[0]?.mark?.type === "line") {
      source.layer[0]?.text?.forEach(text => {
        if (text.type === "on-mark") {
          rules.push({
            category: "recommender",
            description: `Remove mark labels for ${text.field}`,
            specifier: { role: "mark.label", mark: "line", field: text.field },
            action: "remove"
          });
        }
      });
    }
  }
  return rules;
}